/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import toastr from '@/lib/notifications';
import $ from 'jquery';
import store from '../state/store';

store.on('enquiry:learner_subjects:index', function(enquiry_id) {
  const params =
    {enquiry_id};

  return $.ajax({
    url: "/api/sales/enquiry_learner_subjects",
    type: 'GET',
    dataType: 'json',
    contentType: 'application/json',
    data: params,
    success: (data) => {
      return store.get().enquiry.set({learner_subjects: data.items});
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

store.on('enquiry:learner_subjects:create', function(enquiry_id, enquiry_learner_id) {
  const params = {
    enquiry_id,
    enquiry_learner_id,
    subject_name: '',
    subject_category_name: '',
    subject_level_name: '',
    syllabus: ''
  };

  return $.ajax({
    url: "/api/sales/enquiry_learner_subjects",
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      store.emit('enquiry:learner_subjects:index', enquiry_id);
      return store.emit('enquiry:subjects:index', enquiry_id);
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

store.on('enquiry:learner_subjects:update', function(enquiry_id, learner_subject_id, params) {
  if (params == null) { params = {}; }
  const request_params = {
    learner_subject_id,
    subject_name: params.subject_name,
    subject_category_name: params.subject_category_name,
    subject_level_name: params.subject_level_name,
    syllabus: params.syllabus,
    result: params.result,
    focus_areas: params.focus_areas
  };

  return $.ajax({
    url: `/api/sales/enquiry_learner_subjects/${learner_subject_id}`,
    type: 'PUT',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(request_params),
    success: (data) => {
      store.emit('enquiry:learner_subjects:index', enquiry_id);
      store.emit('enquiry:learners:index', enquiry_id);
      store.emit('enquiry:subjects:index', enquiry_id);
      return store.emit('enquiry:lesson_plans:index', enquiry_id);
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

store.on('enquiry:learner_subjects:destroy', function(enquiry_id, learner_subject_id) {
  $.ajax({
    url: `/api/sales/enquiry_learner_subjects/${learner_subject_id}`,
    type: 'DELETE',
    dataType: 'json',
    contentType: 'application/json',
    success: (data) => {
      store.emit('enquiry:learner_subjects:index', enquiry_id);
      return store.emit('enquiry:subjects:index', enquiry_id);
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  })
});

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}